export default {"src":"/_next/static/media/rtm-logo-black.d36e95ba.svg","height":32,"width":134,"blurWidth":0,"blurHeight":0};